import {ProductRole as ProductRoleV1} from './../types';
import {UserInfo} from './../user/types';
import {validProductRoles as validProductRolesV1} from './constants';
import {DisplayRole, OrgRole, OrgRoles, ProductRole, validProductRoles} from './rolesV2';

export const isOrgOwner = (roles: OrgRoles | OrgRoles[]): boolean => {
  // takes in a single role or an array of roles (standard or display)
  if (Array.isArray(roles)) {
    return roles.includes(OrgRole.OWNER) || roles.includes(DisplayRole.OWNER);
  } else {
    return roles === OrgRole.OWNER || roles === DisplayRole.OWNER;
  }
};

export const isUserOrgAdmin = (userinfo: UserInfo): boolean => {
  return userinfo?.memberAccess?.orgAccess?.org_admin || isOrgAdmin(userinfo?.roles);
};

export const isUserOrgIAMAdmin = (userinfo: UserInfo): boolean => {
  return userinfo?.memberAccess?.orgAccess?.org_iam_admin;
};

export const isUserOrgOwner = (userinfo: UserInfo): boolean => {
  return userinfo?.memberAccess?.orgAccess?.org_owner || isOrgOwner(userinfo?.roles);
};

export const isUserOrgUser = (userinfo: UserInfo): boolean => {
  return userinfo?.memberAccess?.orgAccess?.org_user || isOrgUser(userinfo?.roles);
};

export const isUserOrgBillingReader = (userinfo: UserInfo): boolean => {
  return userinfo?.roles?.includes(OrgRole.BILLING_READER) ?? false;
};

export const isOrgAdmin = (roles: OrgRoles | OrgRoles[]): boolean => {
  // takes in a single role or an array of roles (standard or display)
  if (Array.isArray(roles)) {
    return roles.includes(OrgRole.ADMIN) || roles.includes(DisplayRole.ADMIN);
  } else {
    return roles === OrgRole.ADMIN || roles === DisplayRole.ADMIN;
  }
};

export const isOrgOwnerOrAdmin = (roles: OrgRoles | OrgRoles[]): boolean => {
  // takes in a single role or an array of roles (standard or display)
  if (Array.isArray(roles)) {
    return (
      roles.includes(OrgRole.ADMIN) ||
      roles.includes(DisplayRole.ADMIN) ||
      roles.includes(OrgRole.OWNER) ||
      roles.includes(DisplayRole.OWNER)
    );
  } else {
    return (
      roles === OrgRole.ADMIN ||
      roles === DisplayRole.ADMIN ||
      roles === (OrgRole.OWNER) ||
      roles === DisplayRole.OWNER
    );
  }
};

export const isUserWorkspaceAdmin = (userinfo: UserInfo, workspaceName: string): boolean => {
  return userinfo?.memberAccess?.workspaceAccess?.[workspaceName]?.ws_admin;
};

export const isUserWorkspaceOwner = (userinfo: UserInfo, workspaceName: string): boolean => {
  return userinfo?.memberAccess?.workspaceAccess?.[workspaceName]?.ws_owner;
};

export const isOrgUser = (roles: OrgRoles | OrgRoles[]): boolean => {
  // takes in a single role or an array of roles (standard or display)
  if (Array.isArray(roles)) {
    return roles.includes(OrgRole.USER) || roles.includes(DisplayRole.USER);
  } else {
    return roles === OrgRole.USER || roles === DisplayRole.USER;
  }
};

export const isValidOrgRole = (role: string): boolean => {
  return Object.values(OrgRole).includes(role as OrgRole);
};

export const isValidProductRole = (role: string): boolean => {
  let valid = false;

  if (role.includes('_') && !role.startsWith('product_')) {
    valid =
      validProductRolesV1.includes(role as ProductRoleV1) || validProductRolesV1.includes(`${role}_` as ProductRoleV1);
  } else {
    valid = validProductRoles.includes(role as ProductRole);
  }

  return valid;
};
